import {
  CLEAR_EDIT_LEAGUE,
  EDIT_LEAGUE_ERROR,
  EDIT_LEAGUE_LOADING,
  EDIT_LEAGUE_SUCCESS,
} from "../../../constant/actionTypes";

const editLeagueReducer = (state = {}, action) => {
  switch (action.type) {
    case EDIT_LEAGUE_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case EDIT_LEAGUE_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case EDIT_LEAGUE_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case CLEAR_EDIT_LEAGUE: {
      let obj = {};
      return obj;
    }
    default:
      return state;
  }
};

export default editLeagueReducer;
